import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {checkFormValidity, formatDate, handleDefaultValues} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../../components/MDButton";
import MDTypography from "../../../components/MDTypography";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";
import {addDays} from "@fullcalendar/core/internal";

export default function ClientManageAccountModal(props) {

  const [account, setAccount] = useState(props?.account);
  const [billingEndDate, setBillingEndDate] = useState(null);
  const [numberVisits, setNumberVisits] = useState(props?.account?.numberVisits);

  const [minCancelRestrictions, setMinCancelRestrictions] = useState(false);
  const [minCancelNotification, setMinCancelNotification] = useState(false);

  useEffect(() => {
    setMinCancelRestrictions(account?.minimumCancellationDate && new Date(account?.minimumCancellationDate).getTime() > new Date().getTime());
  }, [props?.account.minimumCancellationDate]);

  useEffect(() => {
    setMinCancelNotification(account.minimumCancellationDays);
  }, [props?.account.minimumCancellationDays]);

  useEffect(() => {
    setBillingEndDate(null);
    if (props?.account?.billingEndDate) {
      setBillingEndDate(new Date(props?.account?.billingEndDate));
    }
  }, [props?.account?.billingEndDate]);

  useEffect(() => {
    if (props?.account) {
      setAccount(props?.account);
    }
  }, [props?.account]);

  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    let _account = {...account};
    _account.billingEndDate = billingEndDate;
    setAccount(_account);
  }, [billingEndDate]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(account)
  });

  const handleClose = () => {
    props.handleClose();
  };


  const handleSave = (data) => {
    props.handleSave(data);
  };

  const getNextBillingDate = (account) => {
    let d = new Date();
    let minCancelDate = addDays(d, account?.minimumCancellationDays || 0);
    let nextBillingDate = new Date(account.nextBillDate);
    if (minCancelDate.getTime() > nextBillingDate.getTime()) {
      return addDays(nextBillingDate, 30);
    }
    return minCancelDate;
  }

  return (
    <Modal onHide={handleClose} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-medium'}
           show={props.show}>
      <form
        onChange={(e) => setFormInvalid(!!!checkFormValidity(e))}
        onSubmit={handleSubmit(handleSave)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Member Account</Modal.Title>
        </Modal.Header>
        {account && <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <MDTypography variant={'h6'} className={'mb-2'}>{account?.accountType?.name}</MDTypography>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>

                    <div className={'mt-2'}>
                      {minCancelRestrictions && <>
                        <p><b>Your membership is currently within its minimum commitment period.</b></p>
                        <p>This membership requires a minimum commitment of {account?.minMembershipMonths} months.
                          You’ll be able to cancel your
                          membership after {formatDate(account?.minimumCancellationDate)}.</p>
                      </>}

                      {minCancelNotification && <>
                        <p><b>This membership requires {account?.minimumCancellationDays} days notice to cancel.</b></p>
                        <p>Because of this notice period, your membership may renew before your cancellation takes
                          effect. Your membership will remain active through the end of the applicable billing period
                          after the <b>{account?.minimumCancellationDays}-day</b> notice requirement is met.
                        </p>
                      </>}

                      {account?.nextBillDate && <>
                        <p><b>Next Scheduled Billing Date:</b> {formatDate(account.nextBillDate)}
                        </p>
                      </>
                      }
                      {account?.minimumCancellationDays && <>
                        <p><b>Cancellation Date:</b> {formatDate(getNextBillingDate(account))}</p>
                      </>}
                    </div>

                    {!minCancelRestrictions && <>
                      <div className={'col col-sm-12 col-md-12 col-lg-12'}>
                        <label htmlFor={'cancelReason'}>Reason for cancellation (optional)</label>
                        <textarea
                          placeholder={"Reason for cancellation"}
                          maxLength={500}
                          rows={5}
                          name="cancelReason"
                          id="cancelReason"
                          {...register('cancelReason', {})}
                          className={'form-control mt-2'}/>
                      </div>
                    </>
                    }
                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>}
        <Modal.Footer>
          <MDButton style={{
            position: 'relative',
            left: '-10px'
          }} type="button" color="primary" onClick={() => {
            handleClose();
          }}>
            Back
          </MDButton>

          {!minCancelRestrictions &&
            <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
              {props.saving ? 'Saving...' : 'Confirm Cancellation'}
            </MDButton>
          }
        </Modal.Footer>
      </form>
    </Modal>
  );
}